import { useQuery } from "convex/react";
import { Link } from "react-router";

import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { api } from "../../../../convex/_generated/api";
import { Mail } from "./mail";
import type { MailAccount } from "./types";

export default function MailPage() {
	const accountsQuery = useQuery(api.mail.queries.listAccounts);
	const accounts = (accountsQuery ?? []) as MailAccount[];
	const isLoading = accountsQuery === undefined;

	if (isLoading) {
		return (
			<div className="flex h-full items-center justify-center p-8 text-sm text-muted-foreground">
				Loading mail…
			</div>
		);
	}

	if (accounts.length === 0) {
		return (
			<div className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center">
				<div>
					<h1 className="text-xl font-semibold">No mailboxes connected</h1>
					<p className="text-sm text-muted-foreground">
						Connect a Gmail or Outlook account to start ingesting mail.
					</p>
				</div>
				<Link
					to="/workspace/connections"
					className={cn(buttonVariants({ variant: "default" }))}
				>
					Connect an account
				</Link>
			</div>
		);
	}

	return (
		<div className="flex h-full flex-col">
			<Mail
				accounts={accounts}
				defaultLayout={[20, 32, 48]}
				navCollapsedSize={4}
			/>
		</div>
	);
}
